package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UScreen(
    @SerialName("id") val id: String,
    @SerialName("progressBar") val progressBar: Boolean = true,
    @SerialName("statusBar") val statusBar: StatusBarStyle = StatusBarStyle.Dark,
    @SerialName("platform") val platform: String? = null,
    @SerialName("background") val background: UScreenBackground? = null,
    @SerialName("blocks") val blocks: List<UScreenBlock>,
    @SerialName("cta") val cta: UScreenCta? = null,
) {
    companion object {
        val preview = UScreen(
            id = "preview_screen",
            blocks = listOf(
                ImageBlock.preview,
                SpacerBlock(height = 24),
                LabelBlock.preview,
                SpacerBlock(height = 16),
                ChoiceListBlock.preview,
            ),
            cta = UScreenCta.preview,
        )
    }
}
